import { render, staticRenderFns } from "./createSetor.vue?vue&type=template&id=91528f86&scoped=true&"
import script from "./createSetor.vue?vue&type=script&lang=js&"
export * from "./createSetor.vue?vue&type=script&lang=js&"
import style0 from "./createSetor.vue?vue&type=style&index=0&id=91528f86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91528f86",
  null
  
)

export default component.exports